import { useParams } from 'react-router-dom';
import * as urlUtil from '../utils/url.utils';

export const useGetPageRoutingURL = (href) => {
    const { pathLang } = useParams();

    if (!href) {
        return '';
    }

    if (urlUtil.isExternalUrl(href) || urlUtil.isHashLink(href)) {
        return href;
    }

    const pathWithParamsAndHash = urlUtil.getPathWithParamsAndHash(href);
    const { cleanUrl, lang } = urlUtil.parseUrl(pathWithParamsAndHash);

    const selectedPathLang = pathLang ? `/${pathLang}` : '';

    return lang ? href : `${selectedPathLang}${cleanUrl}`;
};
